/**
 * ArticleLayoutCollaborative - Collaborative article layout wrapper
 * Applies CSS class for collaboration-focused styling
 */
import React from 'react';

const ArticleLayoutCollaborative = ({ children }) => {
    return (
        <div className="article-layout article-layout--collaborative">
            <div className="article-layout__body">
                {children}
            </div>
        </div>
    );
};

export default ArticleLayoutCollaborative;
